import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// React Toastify
import { toast } from "react-toastify";

// Redux API
import { useLoginMutation } from "../../redux/api/authApi";
import { useSelector } from "react-redux";


const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [login, { isLoading, error}] = useLoginMutation();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const submitHandler = async (e) => {
    e.preventDefault();
    const loginData = {
      email,
      password,
    };
    await login(loginData);   
  };

   useEffect(() => {
     if (isAuthenticated) {
       toast.success("Login Successful");
       navigate("/");
     }
     if (error) {
       toast.error(error?.data?.message);
     }
   }, [isAuthenticated, error, navigate]);

  


  return (
    <div className="flex flex-wrap signup-login-page-content">
      <div className="w-full md:w-1/2 text-center">
        <div className="mx-auto login-image-section">
          <img
            src="../img/welcome_back.png"
            alt="Welcome Back"
            loading="lazy"
            className="mx-auto"
          />
        </div>
      </div>
      <div className="w-full md:w-1/2">
        <section className="login-signup-section login-section p-4">
          <form onSubmit={submitHandler} className="space-y-4">
            <Link to="/">
              <Image
                src="../img/new_logo_grey.png"
                alt="Creatyea Technology"
                className="mx-auto"
              />
            </Link>
            <span className="block">Hello. We've been expecting you</span>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="form-input username w-full px-4 py-2 border border-gray-300 rounded-md"
            />
            <input
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="form-input password w-full px-4 py-2 border border-gray-300 rounded-md"
            />
            <span className="sub-options block">
              <Link
                to="/forgot_password"
                className="text-blue-600 hover:text-blue-700"
              >
                Forgot Password?
              </Link>
            </span>
            <button
              type="submit"
              disabled={isLoading}
              className={`btn-primary ${
                isLoading ? "bg-gray-500" : "bg-blue-500 hover:bg-blue-700"
              } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
            >
              {isLoading ? <i className="fas fa-spinner fa-spin"></i> : "Login"}
            </button>
          </form>
        </section>
        <br />
        <section className="social-media-login-section">
          {/* Social media login options can be added here */}
        </section>
        <section className="mini-signup-section text-center mt-4">
          <h4 className="text-lg">New to Creatyea Technology?</h4>
          <p>
            Create an Account and get updated about new products on the
            marketplace and track your shipping as well
          </p>
          <Link
            to="/signup"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mt-4 inline-block"
          >
            Sign Up
          </Link>
        </section>
      </div>
      <footer className="w-full customer-login-footer text-center mt-4 p-4">
        <Link
          to="/privacy_policy"
          className="text-blue-600 hover:text-blue-700"
        >
          Privacy Policy
        </Link>
        <Link
          to="/terms_conditions"
          className="ml-4 text-blue-600 hover:text-blue-700"
        >
          Terms & Conditions
        </Link>
      </footer>
    </div>
  );
};

export default Login;
